import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

import {
  Card,
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'
import { ChurnReasonsTable } from './components'

import { Plus as PlusIcon } from 'react-feather'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'

import constants from 'constants/index'

import * as service from 'service'
import { useHistory } from 'react-router-dom'
import { routes } from 'Routes'

const ChurnReasonsMain = () => {
  const history = useHistory()
  const filter = useFilter()

  const theme = useTheme()
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { response, isLoading, refresh } = useFetch(
    service.dponet.churnReasons.get,
    {
      ...{ ...filter.filters },
      perPage,
      page,
    },
    [page, perPage, filter.filters],
  )

  return (
    <Page title="Motivos de churn">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          title="Listagem"
          menu="Motivos de churn"
          subtitle="Motivos de churn"
          filter={filter}
          notSpecificTags
        >
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <Card
          title="Motivos de churn"
          actionButton={
            <Permitted tag={constants.permissions.CHURN_REASONS.CREATE}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<PlusIcon />}
                onClick={() => history.push(routes.churnReasons.new)}
              >
                Criar
              </Button>
            </Permitted>
          }
        >
          {!isLoading && (
            <ChurnReasonsTable
              churnReasons={response?.data?.churnReasons || []}
              refresh={refresh}
            />
          )}
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount ?? 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </Card>
      </Container>
      <Filters filter={filter}>
        <input textfieldinput="true" label="Nome" name="name" />
      </Filters>
    </Page>
  )
}

export default ChurnReasonsMain
